module.exports = __webpack_public_path__ + "static/img/dentaire-04.5042f69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dentaire-04.png
// module id = 84
// module chunks = 0